<template>
  <v-tooltip bottom>
    <v-icon v-if="isValid()" small color="green lighten-1" slot="activator" style="font-size:25px;"
      >check_circle</v-icon
    >
    <v-icon v-if="revisar()" small color="red lighten-1" slot="activator" style="font-size:25px;"
      >error</v-icon
    >
    <span>{{ correction }}</span>
  </v-tooltip>
</template>

<script>
import Constants from '../../../../common/constants'

export default {
  props: {
    correction: String
  },

  methods: {
    isValid () {
      return this.correction === Constants.IS_FIELD_VALID
    },
    revisar () {
      return this.correction === Constants.IS_FIELD_REVISAR
    }
  }
}
</script>
